// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

// This was generated using spacetimedb cli version 1.12.0 (commit a6655bffd4631992dd720b398c50e7e7afd4d39e).

/* eslint-disable */
/* tslint:disable */
import {
  DbConnectionBuilder as __DbConnectionBuilder,
  DbConnectionImpl as __DbConnectionImpl,
  SubscriptionBuilderImpl as __SubscriptionBuilderImpl,
  TypeBuilder as __TypeBuilder,
  Uuid as __Uuid,
  convertToAccessorMap as __convertToAccessorMap,
  makeQueryBuilder as __makeQueryBuilder,
  procedureSchema as __procedureSchema,
  procedures as __procedures,
  reducerSchema as __reducerSchema,
  reducers as __reducers,
  schema as __schema,
  t as __t,
  table as __table,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type DbConnectionConfig as __DbConnectionConfig,
  type ErrorContextInterface as __ErrorContextInterface,
  type Event as __Event,
  type EventContextInterface as __EventContextInterface,
  type Infer as __Infer,
  type QueryBuilder as __QueryBuilder,
  type ReducerEventContextInterface as __ReducerEventContextInterface,
  type RemoteModule as __RemoteModule,
  type SubscriptionEventContextInterface as __SubscriptionEventContextInterface,
  type SubscriptionHandleImpl as __SubscriptionHandleImpl,
} from "spacetimedb";

// Import and reexport all reducer arg types
import AddBattlePassXpReducer from "./add_battle_pass_xp_reducer";
export { AddBattlePassXpReducer };
import AddBundleItemReducer from "./add_bundle_item_reducer";
export { AddBundleItemReducer };
import AddRegionReducer from "./add_region_reducer";
export { AddRegionReducer };
import AddStoreItemReducer from "./add_store_item_reducer";
export { AddStoreItemReducer };
import AdminGrantCoinsReducer from "./admin_grant_coins_reducer";
export { AdminGrantCoinsReducer };
import AdminGrantItemReducer from "./admin_grant_item_reducer";
export { AdminGrantItemReducer };
import ApplyDailyDecayReducer from "./apply_daily_decay_reducer";
export { ApplyDailyDecayReducer };
import BlockUserReducer from "./block_user_reducer";
export { BlockUserReducer };
import BuyLuckyTilePickReducer from "./buy_lucky_tile_pick_reducer";
export { BuyLuckyTilePickReducer };
import BuyPremiumPassReducer from "./buy_premium_pass_reducer";
export { BuyPremiumPassReducer };
import CheckEmailVerifiedReducer from "./check_email_verified_reducer";
export { CheckEmailVerifiedReducer };
import ClaimAccountReducer from "./claim_account_reducer";
export { ClaimAccountReducer };
import ClaimAccountGoogleReducer from "./claim_account_google_reducer";
export { ClaimAccountGoogleReducer };
import ClaimBattlePassRewardReducer from "./claim_battle_pass_reward_reducer";
export { ClaimBattlePassRewardReducer };
import ClaimChallengeRewardReducer from "./claim_challenge_reward_reducer";
export { ClaimChallengeRewardReducer };
import CleanupCompletedMatchesReducer from "./cleanup_completed_matches_reducer";
export { CleanupCompletedMatchesReducer };
import CompleteEmailVerificationReducer from "./complete_email_verification_reducer";
export { CompleteEmailVerificationReducer };
import CreateGuestAccountReducer from "./create_guest_account_reducer";
export { CreateGuestAccountReducer };
import CreatePendingPurchaseReducer from "./create_pending_purchase_reducer";
export { CreatePendingPurchaseReducer };
import CreatePrivateMatchReducer from "./create_private_match_reducer";
export { CreatePrivateMatchReducer };
import CreateRaceMatchReducer from "./create_race_match_reducer";
export { CreateRaceMatchReducer };
import CreateStoreBundleReducer from "./create_store_bundle_reducer";
export { CreateStoreBundleReducer };
import CreateStorePromoReducer from "./create_store_promo_reducer";
export { CreateStorePromoReducer };
import CreateTurnTacticsMatchReducer from "./create_turn_tactics_match_reducer";
export { CreateTurnTacticsMatchReducer };
import DeleteStoreItemReducer from "./delete_store_item_reducer";
export { DeleteStoreItemReducer };
import EndStorePromoReducer from "./end_store_promo_reducer";
export { EndStorePromoReducer };
import EnterTournamentReducer from "./enter_tournament_reducer";
export { EnterTournamentReducer };
import EquipItemReducer from "./equip_item_reducer";
export { EquipItemReducer };
import FinalizeTournamentReducer from "./finalize_tournament_reducer";
export { FinalizeTournamentReducer };
import GenerateDailyDealsReducer from "./generate_daily_deals_reducer";
export { GenerateDailyDealsReducer };
import GetOrCreateLuckyBoardReducer from "./get_or_create_lucky_board_reducer";
export { GetOrCreateLuckyBoardReducer };
import GiftCoinsReducer from "./gift_coins_reducer";
export { GiftCoinsReducer };
import GiftItemReducer from "./gift_item_reducer";
export { GiftItemReducer };
import JoinPrivateMatchReducer from "./join_private_match_reducer";
export { JoinPrivateMatchReducer };
import JoinQueueReducer from "./join_queue_reducer";
export { JoinQueueReducer };
import LeaveMatchDirectoryReducer from "./leave_match_directory_reducer";
export { LeaveMatchDirectoryReducer };
import LeaveQueueReducer from "./leave_queue_reducer";
export { LeaveQueueReducer };
import LoginReducer from "./login_reducer";
export { LoginReducer };
import LoginGoogleReducer from "./login_google_reducer";
export { LoginGoogleReducer };
import MarkMessagesReadReducer from "./mark_messages_read_reducer";
export { MarkMessagesReadReducer };
import PickLuckyTileReducer from "./pick_lucky_tile_reducer";
export { PickLuckyTileReducer };
import PingReducer from "./ping_reducer";
export { PingReducer };
import ProcessCoinPurchaseReducer from "./process_coin_purchase_reducer";
export { ProcessCoinPurchaseReducer };
import ProcessMatchmakingQueueReducer from "./process_matchmaking_queue_reducer";
export { ProcessMatchmakingQueueReducer };
import ProcessRefundReducer from "./process_refund_reducer";
export { ProcessRefundReducer };
import ProcessSubscriptionEventReducer from "./process_subscription_event_reducer";
export { ProcessSubscriptionEventReducer };
import PurchaseBundleReducer from "./purchase_bundle_reducer";
export { PurchaseBundleReducer };
import PurchaseDailyDealReducer from "./purchase_daily_deal_reducer";
export { PurchaseDailyDealReducer };
import PurchaseItemReducer from "./purchase_item_reducer";
export { PurchaseItemReducer };
import RecalculateRankedPlazasReducer from "./recalculate_ranked_plazas_reducer";
export { RecalculateRankedPlazasReducer };
import RefreshSeasonalAvailabilityReducer from "./refresh_seasonal_availability_reducer";
export { RefreshSeasonalAvailabilityReducer };
import RegisterUserReducer from "./register_user_reducer";
export { RegisterUserReducer };
import RemoveBundleItemReducer from "./remove_bundle_item_reducer";
export { RemoveBundleItemReducer };
import RemoveFriendReducer from "./remove_friend_reducer";
export { RemoveFriendReducer };
import RemoveRegionReducer from "./remove_region_reducer";
export { RemoveRegionReducer };
import RemoveStoreItemReducer from "./remove_store_item_reducer";
export { RemoveStoreItemReducer };
import RerollDailyDealsReducer from "./reroll_daily_deals_reducer";
export { RerollDailyDealsReducer };
import ResetDailyLuckyTilesReducer from "./reset_daily_lucky_tiles_reducer";
export { ResetDailyLuckyTilesReducer };
import ResetFirstWinFlagsReducer from "./reset_first_win_flags_reducer";
export { ResetFirstWinFlagsReducer };
import ResetWeeklyLuckyTilesReducer from "./reset_weekly_lucky_tiles_reducer";
export { ResetWeeklyLuckyTilesReducer };
import RespondToFriendRequestReducer from "./respond_to_friend_request_reducer";
export { RespondToFriendRequestReducer };
import RotateDailyChallengesReducer from "./rotate_daily_challenges_reducer";
export { RotateDailyChallengesReducer };
import RotateWeeklyChallengesReducer from "./rotate_weekly_challenges_reducer";
export { RotateWeeklyChallengesReducer };
import SaveReplayReducer from "./save_replay_reducer";
export { SaveReplayReducer };
import SeedRegionsReducer from "./seed_regions_reducer";
export { SeedRegionsReducer };
import SendDirectMessageReducer from "./send_direct_message_reducer";
export { SendDirectMessageReducer };
import SendFriendRequestReducer from "./send_friend_request_reducer";
export { SendFriendRequestReducer };
import SendGlobalChatReducer from "./send_global_chat_reducer";
export { SendGlobalChatReducer };
import SkipBattlePassTierReducer from "./skip_battle_pass_tier_reducer";
export { SkipBattlePassTierReducer };
import SpendCoinsReducer from "./spend_coins_reducer";
export { SpendCoinsReducer };
import StartNewSeasonReducer from "./start_new_season_reducer";
export { StartNewSeasonReducer };
import StoreEmailVerificationReducer from "./store_email_verification_reducer";
export { StoreEmailVerificationReducer };
import SubmitMatchResultReducer from "./submit_match_result_reducer";
export { SubmitMatchResultReducer };
import SubmitTournamentResultReducer from "./submit_tournament_result_reducer";
export { SubmitTournamentResultReducer };
import SyncSoloCoinsReducer from "./sync_solo_coins_reducer";
export { SyncSoloCoinsReducer };
import UnblockUserReducer from "./unblock_user_reducer";
export { UnblockUserReducer };
import UnequipSlotReducer from "./unequip_slot_reducer";
export { UnequipSlotReducer };
import UpdateActivityReducer from "./update_activity_reducer";
export { UpdateActivityReducer };
import UpdateBioReducer from "./update_bio_reducer";
export { UpdateBioReducer };
import UpdateChallengeProgressReducer from "./update_challenge_progress_reducer";
export { UpdateChallengeProgressReducer };
import UpdateMatchStatusReducer from "./update_match_status_reducer";
export { UpdateMatchStatusReducer };
import UpdateProfileReducer from "./update_profile_reducer";
export { UpdateProfileReducer };
import UpdateStoreBundleReducer from "./update_store_bundle_reducer";
export { UpdateStoreBundleReducer };
import UpdateStoreItemReducer from "./update_store_item_reducer";
export { UpdateStoreItemReducer };

// Import and reexport all procedure arg types

// Import and reexport all table handle types
import AchievementRow from "./achievement_table";
export { AchievementRow };
import ActiveMatchDirectoryRow from "./active_match_directory_table";
export { ActiveMatchDirectoryRow };
import BattlePassChallengeRow from "./battle_pass_challenge_table";
export { BattlePassChallengeRow };
import BattlePassSeasonRow from "./battle_pass_season_table";
export { BattlePassSeasonRow };
import BattlePassTierRow from "./battle_pass_tier_table";
export { BattlePassTierRow };
import BundleItemRow from "./bundle_item_table";
export { BundleItemRow };
import ChatRateLimitRow from "./chat_rate_limit_table";
export { ChatRateLimitRow };
import CoinSyncRateLimitRow from "./coin_sync_rate_limit_table";
export { CoinSyncRateLimitRow };
import CoinTransactionRow from "./coin_transaction_table";
export { CoinTransactionRow };
import ConversationRow from "./conversation_table";
export { ConversationRow };
import DailyDealRow from "./daily_deal_table";
export { DailyDealRow };
import DecayLogRow from "./decay_log_table";
export { DecayLogRow };
import DirectMessageRow from "./direct_message_table";
export { DirectMessageRow };
import EmailVerificationRow from "./email_verification_table";
export { EmailVerificationRow };
import FriendRequestRow from "./friend_request_table";
export { FriendRequestRow };
import FriendshipRow from "./friendship_table";
export { FriendshipRow };
import GameRecordRow from "./game_record_table";
export { GameRecordRow };
import GameReplayRow from "./game_replay_table";
export { GameReplayRow };
import GiftLogRow from "./gift_log_table";
export { GiftLogRow };
import GlobalChatMessageRow from "./global_chat_message_table";
export { GlobalChatMessageRow };
import HealthCheckRow from "./health_check_table";
export { HealthCheckRow };
import LoginAttemptRow from "./login_attempt_table";
export { LoginAttemptRow };
import LuckyTilesBoardRow from "./lucky_tiles_board_table";
export { LuckyTilesBoardRow };
import LuckyTilesPickRow from "./lucky_tiles_pick_table";
export { LuckyTilesPickRow };
import MatchmakingQueueRow from "./matchmaking_queue_table";
export { MatchmakingQueueRow };
import PendingPurchaseRow from "./pending_purchase_table";
export { PendingPurchaseRow };
import PrivateMatchRow from "./private_match_table";
export { PrivateMatchRow };
import ProcessedResultRow from "./processed_result_table";
export { ProcessedResultRow };
import PurchaseHistoryRow from "./purchase_history_table";
export { PurchaseHistoryRow };
import RankedPlazaRow from "./ranked_plaza_table";
export { RankedPlazaRow };
import RankedSeasonRow from "./ranked_season_table";
export { RankedSeasonRow };
import RegionRow from "./region_table";
export { RegionRow };
import StoreBundleRow from "./store_bundle_table";
export { StoreBundleRow };
import StoreItemRow from "./store_item_table";
export { StoreItemRow };
import StorePromoRow from "./store_promo_table";
export { StorePromoRow };
import TournamentRow from "./tournament_table";
export { TournamentRow };
import TournamentEntryRow from "./tournament_entry_table";
export { TournamentEntryRow };
import TournamentResultRow from "./tournament_result_table";
export { TournamentResultRow };
import UserRow from "./user_table";
export { UserRow };
import UserBattlePassRow from "./user_battle_pass_table";
export { UserBattlePassRow };
import UserBlockRow from "./user_block_table";
export { UserBlockRow };
import UserChallengeProgressRow from "./user_challenge_progress_table";
export { UserChallengeProgressRow };
import UserInventoryRow from "./user_inventory_table";
export { UserInventoryRow };
import UserLoadoutRow from "./user_loadout_table";
export { UserLoadoutRow };
import UserSubscriptionRow from "./user_subscription_table";
export { UserSubscriptionRow };
import VipTierRow from "./vip_tier_table";
export { VipTierRow };

// Import and reexport all types
import Achievement from "./achievement_type";
export { Achievement };
import AchievementType from "./achievement_type_type";
export { AchievementType };
import ActiveMatchDirectory from "./active_match_directory_type";
export { ActiveMatchDirectory };
import BattlePassChallenge from "./battle_pass_challenge_type";
export { BattlePassChallenge };
import BattlePassSeason from "./battle_pass_season_type";
export { BattlePassSeason };
import BattlePassTier from "./battle_pass_tier_type";
export { BattlePassTier };
import BundleItem from "./bundle_item_type";
export { BundleItem };
import ChatRateLimit from "./chat_rate_limit_type";
export { ChatRateLimit };
import CoinSyncRateLimit from "./coin_sync_rate_limit_type";
export { CoinSyncRateLimit };
import CoinTransaction from "./coin_transaction_type";
export { CoinTransaction };
import Conversation from "./conversation_type";
export { Conversation };
import DailyDeal from "./daily_deal_type";
export { DailyDeal };
import DecayLog from "./decay_log_type";
export { DecayLog };
import Difficulty from "./difficulty_type";
export { Difficulty };
import DirectMessage from "./direct_message_type";
export { DirectMessage };
import EmailVerification from "./email_verification_type";
export { EmailVerification };
import FriendRequest from "./friend_request_type";
export { FriendRequest };
import FriendRequestStatus from "./friend_request_status_type";
export { FriendRequestStatus };
import Friendship from "./friendship_type";
export { Friendship };
import GameMode from "./game_mode_type";
export { GameMode };
import GameRecord from "./game_record_type";
export { GameRecord };
import GameReplay from "./game_replay_type";
export { GameReplay };
import GiftLog from "./gift_log_type";
export { GiftLog };
import GlobalChatMessage from "./global_chat_message_type";
export { GlobalChatMessage };
import HealthCheck from "./health_check_type";
export { HealthCheck };
import LoginAttempt from "./login_attempt_type";
export { LoginAttempt };
import LuckyTilesBoard from "./lucky_tiles_board_type";
export { LuckyTilesBoard };
import LuckyTilesPick from "./lucky_tiles_pick_type";
export { LuckyTilesPick };
import MatchProvisionStatus from "./match_provision_status_type";
export { MatchProvisionStatus };
import MatchmakingQueue from "./matchmaking_queue_type";
export { MatchmakingQueue };
import PendingPurchase from "./pending_purchase_type";
export { PendingPurchase };
import PrivateMatch from "./private_match_type";
export { PrivateMatch };
import ProcessedResult from "./processed_result_type";
export { ProcessedResult };
import PurchaseHistory from "./purchase_history_type";
export { PurchaseHistory };
import QueueStatus from "./queue_status_type";
export { QueueStatus };
import RankTier from "./rank_tier_type";
export { RankTier };
import RankedPlaza from "./ranked_plaza_type";
export { RankedPlaza };
import RankedSeason from "./ranked_season_type";
export { RankedSeason };
import Region from "./region_type";
export { Region };
import RegionStatus from "./region_status_type";
export { RegionStatus };
import StoreBundle from "./store_bundle_type";
export { StoreBundle };
import StoreItem from "./store_item_type";
export { StoreItem };
import StorePromo from "./store_promo_type";
export { StorePromo };
import TacticsBoardPreset from "./tactics_board_preset_type";
export { TacticsBoardPreset };
import TacticsTimeControl from "./tactics_time_control_type";
export { TacticsTimeControl };
import TacticsTimeIncrement from "./tactics_time_increment_type";
export { TacticsTimeIncrement };
import Tournament from "./tournament_type";
export { Tournament };
import TournamentEntry from "./tournament_entry_type";
export { TournamentEntry };
import TournamentResult from "./tournament_result_type";
export { TournamentResult };
import User from "./user_type";
export { User };
import UserBattlePass from "./user_battle_pass_type";
export { UserBattlePass };
import UserBlock from "./user_block_type";
export { UserBlock };
import UserChallengeProgress from "./user_challenge_progress_type";
export { UserChallengeProgress };
import UserInventory from "./user_inventory_type";
export { UserInventory };
import UserLoadout from "./user_loadout_type";
export { UserLoadout };
import UserSubscription from "./user_subscription_type";
export { UserSubscription };
import VipTier from "./vip_tier_type";
export { VipTier };

/** The schema information for all tables in this module. This is defined the same was as the tables would have been defined in the server. */
const tablesSchema = __schema(
  __table({
    name: 'achievement',
    indexes: [
      { name: 'id', algorithm: 'btree', columns: [
        'id',
      ] },
      { name: 'user_id', algorithm: 'btree', columns: [
        'userId',
      ] },
    ],
    constraints: [
      { name: 'achievement_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, AchievementRow),
  __table({
    name: 'active_match_directory',
    indexes: [
      { name: 'match_id', algorithm: 'btree', columns: [
        'matchId',
      ] },
    ],
    constraints: [
      { name: 'active_match_directory_match_id_key', constraint: 'unique', columns: ['matchId'] },
    ],
  }, ActiveMatchDirectoryRow),
  __table({
    name: 'battle_pass_challenge',
    indexes: [
      { name: 'id', algorithm: 'btree', columns: [
        'id',
      ] },
      { name: 'season_id', algorithm: 'btree', columns: [
        'seasonId',
      ] },
    ],
    constraints: [
      { name: 'battle_pass_challenge_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, BattlePassChallengeRow),
  __table({
    name: 'battle_pass_season',
    indexes: [
      { name: 'id', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'battle_pass_season_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, BattlePassSeasonRow),
  __table({
    name: 'battle_pass_tier',
    indexes: [
      { name: 'id', algorithm: 'btree', columns: [
        'id',
      ] },
      { name: 'season_id', algorithm: 'btree', columns: [
        'seasonId',
      ] },
    ],
    constraints: [
      { name: 'battle_pass_tier_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, BattlePassTierRow),
  __table({
    name: 'bundle_item',
    indexes: [
      { name: 'bundle_id', algorithm: 'btree', columns: [
        'bundleId',
      ] },
      { name: 'id', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'bundle_item_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, BundleItemRow),
  __table({
    name: 'chat_rate_limit',
    indexes: [
      { name: 'user_id', algorithm: 'btree', columns: [
        'userId',
      ] },
    ],
    constraints: [
      { name: 'chat_rate_limit_user_id_key', constraint: 'unique', columns: ['userId'] },
    ],
  }, ChatRateLimitRow),
  __table({
    name: 'coin_sync_rate_limit',
    indexes: [
      { name: 'user_id', algorithm: 'btree', columns: [
        'userId',
      ] },
    ],
    constraints: [
      { name: 'coin_sync_rate_limit_user_id_key', constraint: 'unique', columns: ['userId'] },
    ],
  }, CoinSyncRateLimitRow),
  __table({
    name: 'coin_transaction',
    indexes: [
      { name: 'id', algorithm: 'btree', columns: [
        'id',
      ] },
      { name: 'user_id', algorithm: 'btree', columns: [
        'userId',
      ] },
    ],
    constraints: [
      { name: 'coin_transaction_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, CoinTransactionRow),
  __table({
    name: 'conversation',
    indexes: [
      { name: 'id', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'conversation_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, ConversationRow),
  __table({
    name: 'daily_deal',
    indexes: [
      { name: 'id', algorithm: 'btree', columns: [
        'id',
      ] },
      { name: 'user_id', algorithm: 'btree', columns: [
        'userId',
      ] },
    ],
    constraints: [
      { name: 'daily_deal_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, DailyDealRow),
  __table({
    name: 'decay_log',
    indexes: [
      { name: 'id', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'decay_log_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, DecayLogRow),
  __table({
    name: 'direct_message',
    indexes: [
      { name: 'conversation_id', algorithm: 'btree', columns: [
        'conversationId',
      ] },
      { name: 'id', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'direct_message_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, DirectMessageRow),
  __table({
    name: 'email_verification',
    indexes: [
      { name: 'id', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'email_verification_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, EmailVerificationRow),
  __table({
    name: 'friend_request',
    indexes: [
      { name: 'from_user_id', algorithm: 'btree', columns: [
        'fromUserId',
      ] },
      { name: 'id', algorithm: 'btree', columns: [
        'id',
      ] },
      { name: 'to_user_id', algorithm: 'btree', columns: [
        'toUserId',
      ] },
    ],
    constraints: [
      { name: 'friend_request_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, FriendRequestRow),
  __table({
    name: 'friendship',
    indexes: [
      { name: 'id', algorithm: 'btree', columns: [
        'id',
      ] },
      { name: 'user1_id', algorithm: 'btree', columns: [
        'user1Id',
      ] },
      { name: 'user2_id', algorithm: 'btree', columns: [
        'user2Id',
      ] },
    ],
    constraints: [
      { name: 'friendship_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, FriendshipRow),
  __table({
    name: 'game_record',
    indexes: [
      { name: 'id', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'game_record_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, GameRecordRow),
  __table({
    name: 'game_replay',
    indexes: [
      { name: 'id', algorithm: 'btree', columns: [
        'id',
      ] },
      { name: 'user_id', algorithm: 'btree', columns: [
        'userId',
      ] },
    ],
    constraints: [
      { name: 'game_replay_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, GameReplayRow),
  __table({
    name: 'gift_log',
    indexes: [
      { name: 'id', algorithm: 'btree', columns: [
        'id',
      ] },
      { name: 'receiver_id', algorithm: 'btree', columns: [
        'receiverId',
      ] },
      { name: 'sender_id', algorithm: 'btree', columns: [
        'senderId',
      ] },
    ],
    constraints: [
      { name: 'gift_log_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, GiftLogRow),
  __table({
    name: 'global_chat_message',
    indexes: [
      { name: 'id', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'global_chat_message_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, GlobalChatMessageRow),
  __table({
    name: 'health_check',
    indexes: [
      { name: 'id', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'health_check_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, HealthCheckRow),
  __table({
    name: 'login_attempt',
    indexes: [
      { name: 'id', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'login_attempt_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, LoginAttemptRow),
  __table({
    name: 'lucky_tiles_board',
    indexes: [
      { name: 'id', algorithm: 'btree', columns: [
        'id',
      ] },
      { name: 'user_id', algorithm: 'btree', columns: [
        'userId',
      ] },
    ],
    constraints: [
      { name: 'lucky_tiles_board_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, LuckyTilesBoardRow),
  __table({
    name: 'lucky_tiles_pick',
    indexes: [
      { name: 'id', algorithm: 'btree', columns: [
        'id',
      ] },
      { name: 'user_id', algorithm: 'btree', columns: [
        'userId',
      ] },
    ],
    constraints: [
      { name: 'lucky_tiles_pick_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, LuckyTilesPickRow),
  __table({
    name: 'matchmaking_queue',
    indexes: [
      { name: 'user_id', algorithm: 'btree', columns: [
        'userId',
      ] },
    ],
    constraints: [
      { name: 'matchmaking_queue_user_id_key', constraint: 'unique', columns: ['userId'] },
    ],
  }, MatchmakingQueueRow),
  __table({
    name: 'pending_purchase',
    indexes: [
      { name: 'stripe_session_id', algorithm: 'btree', columns: [
        'stripeSessionId',
      ] },
      { name: 'user_id', algorithm: 'btree', columns: [
        'userId',
      ] },
    ],
    constraints: [
      { name: 'pending_purchase_stripe_session_id_key', constraint: 'unique', columns: ['stripeSessionId'] },
    ],
  }, PendingPurchaseRow),
  __table({
    name: 'private_match',
    indexes: [
      { name: 'match_code', algorithm: 'btree', columns: [
        'matchCode',
      ] },
    ],
    constraints: [
      { name: 'private_match_match_code_key', constraint: 'unique', columns: ['matchCode'] },
    ],
  }, PrivateMatchRow),
  __table({
    name: 'processed_result',
    indexes: [
      { name: 'idempotency_key', algorithm: 'btree', columns: [
        'idempotencyKey',
      ] },
    ],
    constraints: [
      { name: 'processed_result_idempotency_key_key', constraint: 'unique', columns: ['idempotencyKey'] },
    ],
  }, ProcessedResultRow),
  __table({
    name: 'purchase_history',
    indexes: [
      { name: 'id', algorithm: 'btree', columns: [
        'id',
      ] },
      { name: 'user_id', algorithm: 'btree', columns: [
        'userId',
      ] },
    ],
    constraints: [
      { name: 'purchase_history_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, PurchaseHistoryRow),
  __table({
    name: 'ranked_plaza',
    indexes: [
      { name: 'user_id', algorithm: 'btree', columns: [
        'userId',
      ] },
    ],
    constraints: [
      { name: 'ranked_plaza_user_id_key', constraint: 'unique', columns: ['userId'] },
    ],
  }, RankedPlazaRow),
  __table({
    name: 'ranked_season',
    indexes: [
      { name: 'id', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'ranked_season_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, RankedSeasonRow),
  __table({
    name: 'region',
    indexes: [
      { name: 'id', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'region_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, RegionRow),
  __table({
    name: 'store_bundle',
    indexes: [
      { name: 'id', algorithm: 'btree', columns: [
        'id',
      ] },
      { name: 'slug', algorithm: 'btree', columns: [
        'slug',
      ] },
    ],
    constraints: [
      { name: 'store_bundle_id_key', constraint: 'unique', columns: ['id'] },
      { name: 'store_bundle_slug_key', constraint: 'unique', columns: ['slug'] },
    ],
  }, StoreBundleRow),
  __table({
    name: 'store_item',
    indexes: [
      { name: 'id', algorithm: 'btree', columns: [
        'id',
      ] },
      { name: 'slug', algorithm: 'btree', columns: [
        'slug',
      ] },
    ],
    constraints: [
      { name: 'store_item_id_key', constraint: 'unique', columns: ['id'] },
      { name: 'store_item_slug_key', constraint: 'unique', columns: ['slug'] },
    ],
  }, StoreItemRow),
  __table({
    name: 'store_promo',
    indexes: [
      { name: 'id', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'store_promo_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, StorePromoRow),
  __table({
    name: 'tournament',
    indexes: [
      { name: 'id', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'tournament_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, TournamentRow),
  __table({
    name: 'tournament_entry',
    indexes: [
      { name: 'id', algorithm: 'btree', columns: [
        'id',
      ] },
      { name: 'tournament_id', algorithm: 'btree', columns: [
        'tournamentId',
      ] },
      { name: 'user_id', algorithm: 'btree', columns: [
        'userId',
      ] },
    ],
    constraints: [
      { name: 'tournament_entry_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, TournamentEntryRow),
  __table({
    name: 'tournament_result',
    indexes: [
      { name: 'id', algorithm: 'btree', columns: [
        'id',
      ] },
      { name: 'tournament_id', algorithm: 'btree', columns: [
        'tournamentId',
      ] },
    ],
    constraints: [
      { name: 'tournament_result_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, TournamentResultRow),
  __table({
    name: 'user',
    indexes: [
      { name: 'id', algorithm: 'btree', columns: [
        'id',
      ] },
      { name: 'username', algorithm: 'btree', columns: [
        'username',
      ] },
    ],
    constraints: [
      { name: 'user_id_key', constraint: 'unique', columns: ['id'] },
      { name: 'user_username_key', constraint: 'unique', columns: ['username'] },
    ],
  }, UserRow),
  __table({
    name: 'user_battle_pass',
    indexes: [
      { name: 'id', algorithm: 'btree', columns: [
        'id',
      ] },
      { name: 'user_id', algorithm: 'btree', columns: [
        'userId',
      ] },
    ],
    constraints: [
      { name: 'user_battle_pass_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, UserBattlePassRow),
  __table({
    name: 'user_block',
    indexes: [
      { name: 'blocked_user_id', algorithm: 'btree', columns: [
        'blockedUserId',
      ] },
      { name: 'blocker_user_id', algorithm: 'btree', columns: [
        'blockerUserId',
      ] },
      { name: 'id', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'user_block_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, UserBlockRow),
  __table({
    name: 'user_challenge_progress',
    indexes: [
      { name: 'challenge_id', algorithm: 'btree', columns: [
        'challengeId',
      ] },
      { name: 'id', algorithm: 'btree', columns: [
        'id',
      ] },
      { name: 'user_id', algorithm: 'btree', columns: [
        'userId',
      ] },
    ],
    constraints: [
      { name: 'user_challenge_progress_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, UserChallengeProgressRow),
  __table({
    name: 'user_inventory',
    indexes: [
      { name: 'id', algorithm: 'btree', columns: [
        'id',
      ] },
      { name: 'user_id', algorithm: 'btree', columns: [
        'userId',
      ] },
    ],
    constraints: [
      { name: 'user_inventory_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, UserInventoryRow),
  __table({
    name: 'user_loadout',
    indexes: [
      { name: 'user_id', algorithm: 'btree', columns: [
        'userId',
      ] },
    ],
    constraints: [
      { name: 'user_loadout_user_id_key', constraint: 'unique', columns: ['userId'] },
    ],
  }, UserLoadoutRow),
  __table({
    name: 'user_subscription',
    indexes: [
      { name: 'user_id', algorithm: 'btree', columns: [
        'userId',
      ] },
    ],
    constraints: [
      { name: 'user_subscription_user_id_key', constraint: 'unique', columns: ['userId'] },
    ],
  }, UserSubscriptionRow),
  __table({
    name: 'vip_tier',
    indexes: [
      { name: 'id', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'vip_tier_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, VipTierRow),
);

/** The schema information for all reducers in this module. This is defined the same way as the reducers would have been defined in the server, except the body of the reducer is omitted in code generation. */
const reducersSchema = __reducers(
  __reducerSchema("add_battle_pass_xp", AddBattlePassXpReducer),
  __reducerSchema("add_bundle_item", AddBundleItemReducer),
  __reducerSchema("add_region", AddRegionReducer),
  __reducerSchema("add_store_item", AddStoreItemReducer),
  __reducerSchema("admin_grant_coins", AdminGrantCoinsReducer),
  __reducerSchema("admin_grant_item", AdminGrantItemReducer),
  __reducerSchema("apply_daily_decay", ApplyDailyDecayReducer),
  __reducerSchema("block_user", BlockUserReducer),
  __reducerSchema("buy_lucky_tile_pick", BuyLuckyTilePickReducer),
  __reducerSchema("buy_premium_pass", BuyPremiumPassReducer),
  __reducerSchema("check_email_verified", CheckEmailVerifiedReducer),
  __reducerSchema("claim_account", ClaimAccountReducer),
  __reducerSchema("claim_account_google", ClaimAccountGoogleReducer),
  __reducerSchema("claim_battle_pass_reward", ClaimBattlePassRewardReducer),
  __reducerSchema("claim_challenge_reward", ClaimChallengeRewardReducer),
  __reducerSchema("cleanup_completed_matches", CleanupCompletedMatchesReducer),
  __reducerSchema("complete_email_verification", CompleteEmailVerificationReducer),
  __reducerSchema("create_guest_account", CreateGuestAccountReducer),
  __reducerSchema("create_pending_purchase", CreatePendingPurchaseReducer),
  __reducerSchema("create_private_match", CreatePrivateMatchReducer),
  __reducerSchema("create_race_match", CreateRaceMatchReducer),
  __reducerSchema("create_store_bundle", CreateStoreBundleReducer),
  __reducerSchema("create_store_promo", CreateStorePromoReducer),
  __reducerSchema("create_turn_tactics_match", CreateTurnTacticsMatchReducer),
  __reducerSchema("delete_store_item", DeleteStoreItemReducer),
  __reducerSchema("end_store_promo", EndStorePromoReducer),
  __reducerSchema("enter_tournament", EnterTournamentReducer),
  __reducerSchema("equip_item", EquipItemReducer),
  __reducerSchema("finalize_tournament", FinalizeTournamentReducer),
  __reducerSchema("generate_daily_deals", GenerateDailyDealsReducer),
  __reducerSchema("get_or_create_lucky_board", GetOrCreateLuckyBoardReducer),
  __reducerSchema("gift_coins", GiftCoinsReducer),
  __reducerSchema("gift_item", GiftItemReducer),
  __reducerSchema("join_private_match", JoinPrivateMatchReducer),
  __reducerSchema("join_queue", JoinQueueReducer),
  __reducerSchema("leave_match_directory", LeaveMatchDirectoryReducer),
  __reducerSchema("leave_queue", LeaveQueueReducer),
  __reducerSchema("login", LoginReducer),
  __reducerSchema("login_google", LoginGoogleReducer),
  __reducerSchema("mark_messages_read", MarkMessagesReadReducer),
  __reducerSchema("pick_lucky_tile", PickLuckyTileReducer),
  __reducerSchema("ping", PingReducer),
  __reducerSchema("process_coin_purchase", ProcessCoinPurchaseReducer),
  __reducerSchema("process_matchmaking_queue", ProcessMatchmakingQueueReducer),
  __reducerSchema("process_refund", ProcessRefundReducer),
  __reducerSchema("process_subscription_event", ProcessSubscriptionEventReducer),
  __reducerSchema("purchase_bundle", PurchaseBundleReducer),
  __reducerSchema("purchase_daily_deal", PurchaseDailyDealReducer),
  __reducerSchema("purchase_item", PurchaseItemReducer),
  __reducerSchema("recalculate_ranked_plazas", RecalculateRankedPlazasReducer),
  __reducerSchema("refresh_seasonal_availability", RefreshSeasonalAvailabilityReducer),
  __reducerSchema("register_user", RegisterUserReducer),
  __reducerSchema("remove_bundle_item", RemoveBundleItemReducer),
  __reducerSchema("remove_friend", RemoveFriendReducer),
  __reducerSchema("remove_region", RemoveRegionReducer),
  __reducerSchema("remove_store_item", RemoveStoreItemReducer),
  __reducerSchema("reroll_daily_deals", RerollDailyDealsReducer),
  __reducerSchema("reset_daily_lucky_tiles", ResetDailyLuckyTilesReducer),
  __reducerSchema("reset_first_win_flags", ResetFirstWinFlagsReducer),
  __reducerSchema("reset_weekly_lucky_tiles", ResetWeeklyLuckyTilesReducer),
  __reducerSchema("respond_to_friend_request", RespondToFriendRequestReducer),
  __reducerSchema("rotate_daily_challenges", RotateDailyChallengesReducer),
  __reducerSchema("rotate_weekly_challenges", RotateWeeklyChallengesReducer),
  __reducerSchema("save_replay", SaveReplayReducer),
  __reducerSchema("seed_regions", SeedRegionsReducer),
  __reducerSchema("send_direct_message", SendDirectMessageReducer),
  __reducerSchema("send_friend_request", SendFriendRequestReducer),
  __reducerSchema("send_global_chat", SendGlobalChatReducer),
  __reducerSchema("skip_battle_pass_tier", SkipBattlePassTierReducer),
  __reducerSchema("spend_coins", SpendCoinsReducer),
  __reducerSchema("start_new_season", StartNewSeasonReducer),
  __reducerSchema("store_email_verification", StoreEmailVerificationReducer),
  __reducerSchema("submit_match_result", SubmitMatchResultReducer),
  __reducerSchema("submit_tournament_result", SubmitTournamentResultReducer),
  __reducerSchema("sync_solo_coins", SyncSoloCoinsReducer),
  __reducerSchema("unblock_user", UnblockUserReducer),
  __reducerSchema("unequip_slot", UnequipSlotReducer),
  __reducerSchema("update_activity", UpdateActivityReducer),
  __reducerSchema("update_bio", UpdateBioReducer),
  __reducerSchema("update_challenge_progress", UpdateChallengeProgressReducer),
  __reducerSchema("update_match_status", UpdateMatchStatusReducer),
  __reducerSchema("update_profile", UpdateProfileReducer),
  __reducerSchema("update_store_bundle", UpdateStoreBundleReducer),
  __reducerSchema("update_store_item", UpdateStoreItemReducer),
);

/** The schema information for all procedures in this module. This is defined the same way as the procedures would have been defined in the server. */
const proceduresSchema = __procedures(
);

/** The remote SpacetimeDB module schema, both runtime and type information. */
const REMOTE_MODULE = {
  versionInfo: {
    cliVersion: "1.12.0" as const,
  },
  tables: tablesSchema.schemaType.tables,
  reducers: reducersSchema.reducersType.reducers,
  ...proceduresSchema,
} satisfies __RemoteModule<
  typeof tablesSchema.schemaType,
  typeof reducersSchema.reducersType,
  typeof proceduresSchema
>;

/** The tables available in this remote SpacetimeDB module. */
export const tables = __convertToAccessorMap(tablesSchema.schemaType.tables);

/** A typed query builder for this remote SpacetimeDB module. */
export const query: __QueryBuilder<typeof tablesSchema.schemaType> = __makeQueryBuilder(tablesSchema.schemaType);

/** The reducers available in this remote SpacetimeDB module. */
export const reducers = __convertToAccessorMap(reducersSchema.reducersType.reducers);

/** The context type returned in callbacks for all possible events. */
export type EventContext = __EventContextInterface<typeof REMOTE_MODULE>;
/** The context type returned in callbacks for reducer events. */
export type ReducerEventContext = __ReducerEventContextInterface<typeof REMOTE_MODULE>;
/** The context type returned in callbacks for subscription events. */
export type SubscriptionEventContext = __SubscriptionEventContextInterface<typeof REMOTE_MODULE>;
/** The context type returned in callbacks for error events. */
export type ErrorContext = __ErrorContextInterface<typeof REMOTE_MODULE>;
/** The subscription handle type to manage active subscriptions created from a {@link SubscriptionBuilder}. */
export type SubscriptionHandle = __SubscriptionHandleImpl<typeof REMOTE_MODULE>;

/** Builder class to configure a new subscription to the remote SpacetimeDB instance. */
export class SubscriptionBuilder extends __SubscriptionBuilderImpl<typeof REMOTE_MODULE> {}

/** Builder class to configure a new database connection to the remote SpacetimeDB instance. */
export class DbConnectionBuilder extends __DbConnectionBuilder<DbConnection> {}

/** The typed database connection to manage connections to the remote SpacetimeDB instance. This class has type information specific to the generated module. */
export class DbConnection extends __DbConnectionImpl<typeof REMOTE_MODULE> {
  /** Creates a new {@link DbConnectionBuilder} to configure and connect to the remote SpacetimeDB instance. */
  static builder = (): DbConnectionBuilder => {
    return new DbConnectionBuilder(REMOTE_MODULE, (config: __DbConnectionConfig<typeof REMOTE_MODULE>) => new DbConnection(config));
  };

  /** Creates a new {@link SubscriptionBuilder} to configure a subscription to the remote SpacetimeDB instance. */
  override subscriptionBuilder = (): SubscriptionBuilder => {
    return new SubscriptionBuilder(this);
  };
}

